import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./website/website').then((m) => m.Website)
  },
  {
    path: 'About-Us',
    loadComponent: () =>
      import('./about-us-details/about-us-details').then((m) => m.AboutUsDetails)
  },
  {
    path: 'Approach',
    loadComponent: () =>
      import('./approach/approach').then((m) => m.Approach)
  },
  {
  path: 'Collaborate',
  loadComponent: ()=> 
    import('./collaborate/collaborate').then((m)=>m.Collaborate)
  }
];
